export class CommonChecks {
  public static isNullOrUndefined(value: any): boolean {
    return value === null || value === undefined || value === "null" || value === "undefined";
  }
  public static isNullOrEmpty(value: string | undefined | null): boolean {
    return value === null || value === undefined || value === '' || value === "null" || value === "undefined";
  }
  public static isNullOrUndefinedOrEmpty(value: string | undefined | null): boolean {
    return value === null || value === undefined || value === '' || value === "null" || value === "undefined";
  }
  public static isNullOrUndefinedOrEmptyOrWhitespace(value: string | undefined | null | any): boolean {
    return value === null || value === undefined || value === '' || ((typeof(value) === "string") && value.trim() === '') || value === "null" || value === "undefined";
  }

  
}